import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DocumentCategoryAddEdit, DeleteConfirmationModal } from '../../shared';
import { Edit, Delete } from '../../../assets/svg';
import { deleteDocumentCategory, popup } from '../../../utils';
import { DOCUMENT_CATEGORY, QUERY_KEYS, SUCCESS } from '../../../constants';
import { useQueryClient } from '@tanstack/react-query';

export const DocumentCategoryOperation = ({ data, debouncedApiCall }) => {
    const queryClient = useQueryClient()
    const [openEditModal, setOpenEditModal] = useState(false);
    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(0);
    const handleDeleteModalClick = (data) => {
        setSelectedItemId(data?.id);
        setIsDeleteModal(true);
    };

    const handleDeleteClick = async (selectedItemId, setIsDeleteModal) => {
        setTimeout(() => {
            deleteDocumentCategory(selectedItemId)
                .then(() => {
                    queryClient.invalidateQueries({
                        queryKey: [QUERY_KEYS.DOCUMENT_CATEGORY],
                        exact: false,
                    });
                    setIsDeleteModal(false);
                    popup(SUCCESS.SUCCESS_TOAST, DOCUMENT_CATEGORY.DELETED_MESSAGE);
                })
                .catch((error) => {
                    popup('error', error.message);
                });
        }, 500);
    };

    return (
        <>
            <div className='d-flex gap-2 align-items-center justify-content-start'>
                <button
                    className='border-0 p-0 bg-white'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-edit'
                    onClick={() => setOpenEditModal(true)}
                    id='action-btn'
                >
                    <Edit />
                </button>
                <button
                    className='border-0 p-0 bg-white'
                    type='button'
                    data-bs-toggle='modal'
                    data-bs-target='#exampleModal-del'
                    onClick={() => handleDeleteModalClick(data)}
                    id='action-btn'
                >
                    <Delete />
                </button>
            </div>
            {openEditModal && (
                <DocumentCategoryAddEdit
                    openEditModal={openEditModal}
                    setOpenEditModal={setOpenEditModal}
                    data={data}
                    isEdit={true}
                    debouncedApiCall={debouncedApiCall}
                />
            )}
            {isDeleteModal && (
                <DeleteConfirmationModal
                    isDeleteModal={isDeleteModal}
                    setIsDeleteModal={setIsDeleteModal}
                    selectedItemId={selectedItemId}
                    handleDeleteClick={() => handleDeleteClick(selectedItemId, setIsDeleteModal)}
                    deleteButtonName={DOCUMENT_CATEGORY.DELETE_BUTTON}
                />
            )}
        </>
    );
};

DocumentCategoryOperation.propTypes = {
    data: PropTypes.object.isRequired,
    debouncedApiCall: PropTypes.func,
};
